module.exports = __webpack_public_path__ + "img/Willing Risk Taker.ccbdab99.png";